import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import NavBar from './NavBar';
import TopBar from './TopBar';

const DashboardLayout = ({ children }) => {
  const [isMiniDesktopDrawer, setIsMiniDesktopDrawer] = useState(false);
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <Box
      sx={{
        backgroundColor: 'background.dark',
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar
        onDesktopToggle={(isMini) => {
          setIsMiniDesktopDrawer(isMini);
        }}
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <Box
        sx={(theme) => ({
          display: 'flex',
          flex: '1 1 auto',
          overflow: 'hidden',
          paddingTop: '64px',
          [theme.breakpoints.up('lg')]: {
            paddingLeft: isMiniDesktopDrawer
              ? `${theme.spacing(9)} + 1`
              : '256px',
          },
        })}
      >
        <Box sx={{ display: 'flex', flex: '1 1 auto', overflow: 'hidden' }}>
          <Box sx={{ flex: '1 1 auto', height: '100%', overflow: 'auto' }}>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
